import { useFormik } from "formik";
import * as Yup from "yup";
import { IProblem } from "../../../shared/model/problem.model";

interface IFormikProblem {
  initialValues: IProblem;
  saveEntityConfirm: (data: IProblem) => void;
}

export const useFormikProblem = (props: IFormikProblem) => {
  const { initialValues, saveEntityConfirm } = props;

  const formik = useFormik<IProblem>({
    initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object({
      firstName: Yup.string().required("Este campo es requerido"),
      lastName: Yup.string().required("Este campo es requerido"),
      document: Yup.string()
        .required("Este campo es requerido")
        .trim()
        .min(8, "Debe ser de al menos 8 caracteres"),
      mail: Yup.string()
        .required("Este campo es requerido")
        .email("Debe ser un email valido"),
      message: Yup.string()
        .required("Este campo es requerido")
        .min(8, "Debe ser de al menos 8 caracteres"),
    }),
        onSubmit(values) {
      if (formik.isValid) {
        saveEntityConfirm(values);
      }
    },
  });
  return { formik };
};
